import { dispatchIsLoggedIn } from 'actions';

export default () => async (dispatch, _getState, auth) => {
  // cookie does not exists or is expired. Redirect to login page
  if (!auth.isUserLoggedIn()) {
    dispatch(dispatchIsLoggedIn(false));
    return Promise.reject();
  }

  await auth.refreshAccessTokenIfExpired().catch(() => {
    dispatch(dispatchIsLoggedIn(false));
    return Promise.reject();
  });

  dispatch(dispatchIsLoggedIn());
  return Promise.resolve();
};
